import { z } from "zod";

const shipperAndBillToSchema = z.object({
  name: z.string(),
  refClientCode: z.string().nullable(),
  address: z.string(),
  city: z.string(),
  state: z.string(),
  zip: z.string(),
  contactName: z.string().nullable(),
  contactPhone: z.string().nullable(),
  contactEmail: z.string().nullable(),
});

const consigneeSchema = shipperAndBillToSchema.extend({
  website: z.string().nullish(),
  lat: z.number().nullish(),
  lng: z.number().nullish(),
});

const deliveryHoursSchema = z.object({
  startUtc: z.date(),
  endUtc: z.date(),
});

const dimensionsSchema = z.object({
  quantity: z.number().nullable(),
  length: z.number().nullable(),
  width: z.number().nullable(),
  height: z.number().nullable(),
  image: z.string().nullish(),
});

export type Dimensions = z.infer<typeof dimensionsSchema>;

const itemsSummarySchema = z.object({
  pallets: z.number(),
  pieces: z.number(),
  handlingUnits: z.number(),
  weight: z.number(),
  dimensions: z.array(dimensionsSchema).nullish(),
});

const descriptionOfArticlesSchema = z.object({
  seqNumber: z.number(),
  saidToContain: z.string().nullable(),
  description: z.string(),
  commodityCode: z.string(),
  pieces: z.number(),
  weight: z.number(),
});

const proNotesSchema = z.object({
  timestamp: z.date(),
  csrLoginId: z.string().nullable(),
  terminalCode: z.string().nullable(),
  content: z.string().nullable(),
});

const drNotesSchema = z.object({
  timestamp: z.date(),
  recordingParty: z.string().nullable(),
  terminalCode: z.string().nullable(),
  content: z.string().nullable(),
});

export const appointmentRequiredShipmentDetailSchema = z.object({
  consignee: consigneeSchema.nullish(),
  shipper: shipperAndBillToSchema.nullish(),
  billTo: shipperAndBillToSchema.nullish(),
  deliveryHours: deliveryHoursSchema,
  chargeType: z.string(),
  createdByLoginId: z.string().nullable(),
  collectAmount: z.number().nullable(),
  purchaseOrder: z.string().nullable(),
  shipDate: z.date(),
  itemsSummary: itemsSummarySchema,
  descriptionOfArticles: z.array(descriptionOfArticlesSchema),
  doh: z.number(),
  proNotes: z.array(proNotesSchema),
  drNotes: z.array(drNotesSchema),
});

export type AppointmentRequiredShipmentDetail = z.infer<
  typeof appointmentRequiredShipmentDetailSchema
>;

const previousDeliveriesItemSchema = z.object({
  shipmentId: z.number(),
  consigneeId: z.number(),
  consigneeName: z.string(),
  proNumber: z.string(),
  city: z.string(),
  state: z.string(),
  deliveryDateUtc: z.date(),
});

export const previousDeliveriesSchema = z.array(previousDeliveriesItemSchema);

export type PreviousDeliveries = z.infer<typeof previousDeliveriesItemSchema>;
